import { render } from "./PokemonPage.vue?vue&type=template&id=3d1c7b50"
import script from "./PokemonPage.vue?vue&type=script&lang=js"
export * from "./PokemonPage.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\LF\\Desktop\\Vue\\pokemon-game\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__